<template>
  <JoszakiCard
    type="primary"
    class="BlockCitySelector grid md:grid-cols-2 grid-cols-1 relative"
  >
    <IconComponent
      class="absolute z-10 opacity-10 overflow-hidden inset-0 pointer-events-none select-none top-1/2 translate-y-[-50%] left-5 !text-3xl"
      pack="fas"
      icon="map-marker-alt"
    />
    <div class="z-25">
      <span class="text-xl font-bold">
        {{ title ?? $t("citySelector.selectYourCity") }}
      </span>
      <p class="text-sm">
        {{ subTitle ?? $t("citySelector.cities.instruction") }}
      </p>
    </div>
    <div class="z-25 mt-2">
      <AutocompleteCity
        :value="value"
        class="selector"
        :placeholder="$t('citySelector.cities.placeholder')"
        icon-pack="fas"
        icon-right="chevron-down"
        :clearable="true"
        :keep-first="false"
        icon="map-marker-alt"
        typing-tracker-event="Typed in BlockCitySelector"
        @input="selectCity($event)"
        @focus="$trackers.trackClick('BlockCitySelectorField')"
      />
    </div>
  </JoszakiCard>
</template>

<script>
import { useContext } from "@nuxtjs/composition-api";
import AutocompleteCity from "~/components/_refactored/autocomplete/AutocompleteCity.vue";
import IconComponent from "~/components/IconComponent.vue";

export default {
  components: { AutocompleteCity, IconComponent },
  props: {
    value: {
      type: Object,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    subTitle: {
      type: String,
      default: null,
    },
  },
  setup(_props, { emit }) {
    const { $trackers } = useContext();

    const selectCity = (newCity) => {
      $trackers.trackClick("BlockCitySelectorFieldItem");
      emit("select", newCity);
    };

    return {
      selectCity,
      $trackers,
    };
  },
};
</script>
